import PageTitle from "../MainContents/PageTitle/PageTitle";
import styled from 'styled-components';
import { device } from '../MainContents/Style/StyleDevice';
import ScrollToTopOnMount from '../MainContents/AutoScrollTop';
import Tab from "./Tab";




const Main = styled.div`
    margin-top: 100px;
    width: 90%;
    margin: auto;
    @media ${device.mobile}{
        width: 95%;
        position: relative;
    }

`
const Mt = styled.div`
margin-top:130px;
@media ${device.mobile}{
  margin-top:80px;
  }
`;
const Course: React.VFC = () => {
  return (
    <Main>
      <ScrollToTopOnMount />
      <Mt></Mt>
      <PageTitle title={'コース/料金'} englishText={'Course&Price'} />
      {/* <h4>2025年度の情報は現在準備中です</h4> */}
      {/* <h4>最新情報は2025年2月上旬頃に掲載予定です。</h4> */}
      {/* <p>詳細が確定次第、当ホームページにてお知らせいたします。</p> */}
      <Tab />
    </Main>

  );
}
export default Course;